import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OrgDto} from "../dto/org.dto";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {SearchRegistryOfficeRes} from "../dto/search/search-registry-office.res";
import {Observable, tap} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {UrlBuilder} from "../item/url.item";
import {map} from "rxjs/operators";
import {StorageService} from "../../services/storage/storage.service";
import {RegistryOfficeDto} from "../dto/registry-office.dto";

@Injectable({providedIn: 'root'})
export class RegistryOfficeRepo {

  private readonly roRead = '/v1/org/{orgId}/registry-office/{id}';
  private readonly roSearch = '/v1/org/{orgId}/registry-office/search';

  private readonly http = inject(HttpClient);
  private readonly storage = inject(StorageService);
  private readonly registryOfficeStoragePrefix: string = 'registryOffice:';
  private readonly registryOfficeStorageExpireInSec: number = 3600;

  public getByIdCached(org: OrgDto, id: string): Observable<WrapperDto<RegistryOfficeDto>> {
    return this.storage.cache(this.buildCacheKey(org, id), () => {
      const url = UrlBuilder.builder().addPath(this.roRead)
        .addParam('orgId', org.id).addParam('id', id).build();
      return this.http.get<WrapperDto<RegistryOfficeDto>>(url.getUrl(), url.getOptions());
    }, this.registryOfficeStorageExpireInSec)
      .pipe(map((res) => new WrapperDto(res)));
  }

  private buildCacheKey(org: OrgDto, contactId: string): string {
    return this.registryOfficeStoragePrefix + org.id + ':' + contactId;
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchRegistryOfficeRes>> {
    const url = UrlBuilder.builder().addPath(this.roSearch).addParam('orgId', org.id).build();
    return this.http.post<WrapperDto<SearchRegistryOfficeRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchRegistryOfficeRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
